import React, { useState, useEffect } from 'react';
import './DeleteOneProduct.css';
import { API_BASE } from '../api';

const DeleteOneProduct = () => {
    const [product, setProduct] = useState([]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        getAllProducts();
    }, []);

    function getAllProducts() {
        fetch(API_BASE + "/")
            .then((response) => response.json())
            .then((data) => setProduct(Array.isArray(data) ? data : []))
            .catch((err) => console.error("Failed to load products:", err));
    }

    function getOneByOneProductNext() {
        if (product.length > 0) {
            if (index === product.length - 1) setIndex(0);
            else setIndex(index + 1);
        }
    }

    function getOneByOneProductPrev() {
        if (product.length > 0) {
            if (index === 0) setIndex(product.length - 1);
            else setIndex(index - 1);
        }
    }

    function deleteOneProduct(deleteid) {
        if (deleteid == null || deleteid === undefined) return;
        fetch(API_BASE + "/delete", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ _id: Number(deleteid) }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data && data.message) {
                    alert(data.message);
                    getAllProducts();
                }
            })
            .catch((err) => {
                console.error("Delete failed:", err);
                alert("Delete failed. Try again.");
            });
    }

    return (
        <div className="delete-one-product-container">
            <h3>Delete one product</h3>
            <div className="delete-one-product-buttons">
                <button onClick={() => getOneByOneProductPrev()}>Prev</button>
                <button onClick={() => getOneByOneProductNext()}>Next</button>
                <button onClick={() => deleteOneProduct(product[index]?._id)}>Delete</button>
            </div>
            {product[index] && (
                <div className="product-details" key={product[index]._id}>
                    <img
                        src={product[index].image || `https://picsum.photos/seed/${product[index]._id}/150/150`}
                        alt={product[index].title}
                        width={150}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://picsum.photos/seed/${product[index]._id}/150/150`;
                        }}
                    />
                    <label>Id: {product[index]._id}</label>

                    <label>Title: {product[index].title}</label>

                    <label>Category: {product[index].category}</label>

                    <label>Price: {product[index].price}</label>

                    <label>Rate: {product[index].rating.rate}</label>

                    <label>Count: {product[index].rating.count}</label>

                </div>
            )}
            <hr></hr>
        </div>
    );

};

export default DeleteOneProduct;

